module.exports = __webpack_public_path__ + "img/qr-code.5ebdae6b.svg";